/**
 * Content types a sandbox-produced file may render as an `<img>`. An allowlist that must never
 * include `image/svg+xml`, whose embedded scripts would run in the app's origin.
 *
 * Deliberately duplicated from the backend's `INLINE_RENDERABLE_CONTENT_TYPES`
 * (`ai/core/artifact_store.py`): widening one list has no effect until the other is widened too.
 */
export const INLINE_IMAGE_CONTENT_TYPES: ReadonlySet<string> = new Set([
  "image/png",
  "image/jpeg",
  "image/gif",
  "image/webp",
]);
